import React, {useContext} from 'react'
import {Loading} from "../components/Loading";
import {useParams, Navigate} from "react-router-dom";
import {authContext} from "../providers/auth";

const AuthPage = ()=>{
    return <Loading label={"Logging In"}/>
}

export {AuthPage}